import { cn } from "@/lib/utils";

/**
 * The mark: a Lone Star tick seen from above, reduced to what identifies it. A rust
 * body, eight legs, and the single pale spot on the female's back that gives the
 * species its name. Drawn on a 32-unit grid so it stays crisp from 16px to 512px; the
 * favicons in /public (favicon.svg, favicon.png, logo-96.png, apple-touch-icon.png) are
 * rendered from this same geometry.
 */
export const TICK_MARK_PATHS = {
  legs: "M10.2 12.8 7.2 10.4 5.8 7M21.8 12.8 24.8 10.4 26.2 7M9.3 15.7 5.9 14.5 3.6 12.4M22.7 15.7 26.1 14.5 28.4 12.4M9.3 19.3 5.9 20.5 3.6 22.8M22.7 19.3 26.1 20.5 28.4 22.8M10.6 22.6 7.7 25.2 6.6 28.4M21.4 22.6 24.3 25.2 25.4 28.4",
  head: "M13.6 9.2c0-1.9 1.1-3.4 2.4-3.4s2.4 1.5 2.4 3.4",
} as const;

export function TickMark({ className, title }: { className?: string; title?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={cn("shrink-0", className)}
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <g
        fill="none"
        stroke="var(--rust)"
        strokeWidth="1.45"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d={TICK_MARK_PATHS.legs} />
      </g>
      <path d={TICK_MARK_PATHS.head} fill="var(--rust)" />
      <ellipse cx="16" cy="18" rx="7" ry="8.8" fill="var(--rust)" />
      <circle cx="16" cy="15.6" r="2.3" fill="var(--cream)" />
    </svg>
  );
}

/** Mark + wordmark, as used in the header and footer. */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <TickMark className="h-7 w-7" />
      <span className="font-display text-[1.35rem] font-semibold leading-none tracking-[-0.02em] text-foreground">
        LoneStar<span className="text-primary">Map</span>
      </span>
    </span>
  );
}
